import React, { useState, useEffect, useRef } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { defaultNudgeDb } from '../../firebase';

function Admin() {
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setData] = useState({});
    const [dropdownActive, setDropdownActive] = useState(false);
    const [keys, setKeys] = useState([]);
    const dropdownRef = useRef(null);
    const formRef = useRef(null);

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
        setDropdownActive(true);
    };

    const handleDropdown = (event) => {
        event.stopPropagation();
        setDropdownActive(!dropdownActive);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownActive(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    useEffect(() => {
        const dataRef = ref(defaultNudgeDb);
        onValue(dataRef, (snapshot) => {
            if (snapshot.exists()) {
                setData(snapshot.val());
                setKeys(Object.keys(snapshot.val()));
            } else {
                setData({});
                setKeys([]);
            }
        }, {
            onlyOnce: true
        });
    }, []);

    const filteredKeys = keys.filter(key => key.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <div className="relative w-full h-full">
            <div className="absolute inset-0 backdrop-blur-md bg-white bg-opacity-30 w-full h-full"></div>

            <div className="flex flex-col items-center pt-5 w-full relative z-30">
                <form ref={formRef} onSubmit={handleDropdown} className="flex rounded-lg border-none w-auto min-w-[500px] p-2" onClick={handleDropdown}>
                    <input
                        type="text"
                        placeholder="Enter client name"
                        value={searchTerm}
                        onChange={handleChange}
                        className="flex-grow px-4 py-3 text-lg leading-none h-12 outline-none rounded-lg focus:border-orange-500 focus:ring-orange-500"
                        style={{ transition: 'border-color 0.2s' }}
                        onClick={(e) => { e.stopPropagation(); }}
                    />
                    <button type="submit" className="bg-orange-500 text-white px-6 h-12 ml-5 rounded-lg">
                        View Dashboard
                    </button>
                </form>
                {dropdownActive && (
                    <div ref={dropdownRef} className="absolute mt-1 bg-white border border-gray-300 rounded shadow-lg z-40 w-64 overflow-y-scroll" style={{ maxHeight: '270px', left: formRef.current?.offsetLeft, top: formRef.current?.offsetTop + formRef.current?.offsetHeight }}>
                        {filteredKeys.map((key) => (
                            <div key={key} className="px-4 py-2 hover:bg-gray-100 cursor-pointer rounded" onClick={() => {
                                setSearchTerm(key);
                                setDropdownActive(false);
                            }}>
                                {key}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Admin;
